import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'react-feather';
import { InternalLink } from '../internal-link/InternalLink';
import './Pagination.scss';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  basePath: string;
}

export function Pagination({ currentPage, totalPages, basePath }: PaginationProps) {
  const getPageUrl = (page: number) => {
    page = Math.max(page, 1);
    page = Math.min(page, totalPages);
    if (page === 1) {
      return basePath;
    } else {
      return `${basePath}?p=${page}`;
    }
  };

  return (
    <div data-component="Pagination">
      <div className="pagination-content">
        <InternalLink
          to={getPageUrl(1)}
          className="pagination-button"
          data-disabled={currentPage === 1}
        >
          <ChevronsLeft />
        </InternalLink>
        <InternalLink
          to={getPageUrl(currentPage - 1)}
          className="pagination-button"
          data-disabled={currentPage === 1}
        >
          <ChevronLeft />
        </InternalLink>
        <span className="pagination-info">
          Page {currentPage} of {totalPages}
        </span>
        <InternalLink
          to={getPageUrl(currentPage + 1)}
          className="pagination-button"
          data-disabled={currentPage === totalPages}
        >
          <ChevronRight />
        </InternalLink>
        <InternalLink
          to={getPageUrl(totalPages)}
          className="pagination-button"
          data-disabled={currentPage === totalPages}
        >
          <ChevronsRight />
        </InternalLink>
      </div>
    </div>
  );
} 